<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="5" sm="5" md="3">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>

            <v-col cols="7" sm="10" md="9" class="text-right">
              <v-btn-toggle v-model="toggle_exclusive" dense mandatory>
                <v-btn @click="buildTableFormat('grouped')">
                  <v-icon small left>mdi-account-group</v-icon>
                  <span>{{ $t("grouped") }}</span>
                </v-btn>
                <v-btn @click="buildTableFormat('list')">
                  <v-icon small left>mdi-format-list-bulleted</v-icon>
                  <span>{{ $t("list") }}</span>
                </v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col cols="12" v-if="typeList" class="d-md-none mt-3">
              <div class="text-right">
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" md="8" v-if="typeList"> </v-col>
            <v-col cols="12" md="4" v-if="typeList">
              <div class="text-right mt-3">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>

        <div>
          <!-- ======================= -->
          <!-- FORMAT LIST (DATATABLE) -->
          <!-- ======================= -->
          <v-data-table
            :headers="headers"
            :items="dataTable"
            :items-per-page="-1"
            :search="search"
            :mobile-breakpoint="breakpoint"
            class="mb-4"
            v-if="typeList"
            :footer-props="{
              'items-per-page-text': this.$t('rowsPerPage'),
            }"
          >
            <!-- <template v-slot:item.name_regional="{ item }">
              <span class="caption orange--text">{{ item.name_regional }}</span>
            </template>
            <template v-slot:item.name_local="{ item }">
              <span class="caption green--text">{{ item.name_local }}</span>
            </template>
            <template v-slot:item.name_agent="{ item }">
              <span class="caption blue--text">{{ item.name_agent }}</span>
            </template> -->

            <template v-slot:item.name_regional="{ item }">
              <a
                class="orange--text caption"
                @click="
                  $profile.showProfileDrawer(
                    item.id_regional,
                    'administrator/regionals/getRegional'
                  )
                "
              >
                <!-- <v-icon color="orange" x-small>mdi-account-tie</v-icon> -->
                {{ item.name_regional }}
              </a>
            </template>

            <template v-slot:item.name_local="{ item }">
              <a
                class="green--text caption"
                @click="
                  $profile.showProfileDrawer(
                    item.id_local,
                    'administrator/locals/getLocal'
                  )
                "
              >
                <!-- <v-icon color="green" x-small>mdi-account-multiple</v-icon> -->
                {{ item.name_local }}
              </a>
            </template>

            <template v-slot:item.name_agent="{ item }">
              <a
                class="blue--text caption"
                @click="
                  $profile.showProfileDrawer(
                    item.id_agent,
                    'administrator/agents/getAgent'
                  )
                "
              >
                <!-- <v-icon color="primary" x-small>mdi-account</v-icon> -->
                {{ item.name_agent }}
              </a>
            </template>

            <!-- VALUES -->
            <template
              v-for="(value, index) in valueColors"
              v-slot:[`item.${value}`]="{ item }"
            >
              <div :key="`${index} ${Math.random()}`">
                <v-chip
                  x-small
                  v-if="value == 'comission_local'"
                  :class="$vuetify.breakpoint.smAndUp ? 'mr-2' : ''"
                >
                  {{ typeCommissionText(item.type_comission) }}
                </v-chip>
              </div>
              <span
                class="caption"
                :key="index"
                :class="getColor(item[value])"
                >{{ item[value] }}</span
              >
            </template>

            <template
              v-for="(key, index) in keysResume"
              v-slot:[`header.${key}`]="{ header }"
            >
              <span :key="key + index" class="caption">{{ header.text }}</span>
              <v-tooltip top :key="index">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    class="d-print-none"
                  >
                    <v-icon small color="info">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ infoKey(key) }}</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <!-- =================================== -->
          <!-- FORMAT GROUPED USERS (SIMPLE TABLE) -->
          <!-- =================================== -->
          <v-simple-table v-else>
            <thead>
              <tr>
                <th
                  v-for="(head, indexHeader) in headers"
                  :key="`${indexHeader} ${head.value}`"
                >
                  {{ head.text }}
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="d-print-none"
                      >
                        <v-icon small color="info">
                          mdi-information-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ infoKey(head.value) }}</span>
                  </v-tooltip>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in data">
                <tr :key="item.name_regional" class="orange--text">
                  <td :colspan="headers.length">
                    <a
                      class="orange--text"
                      @click="
                        $profile.showProfileDrawer(
                          item.id_regional,
                          'administrator/regionals/getRegional'
                        )
                      "
                    >
                      <v-icon color="orange" small>mdi-account-tie</v-icon>
                      {{ item.name_regional }}
                    </a>
                  </td>
                </tr>

                <template v-for="(local, index) in item.locals">
                  <tr :key="local.name_local" class="green--text darken-3">
                    <td :colspan="headers.length" style="height: 40px">
                      <a
                        class="green--text ml-2"
                        @click="
                          $profile.showProfileDrawer(
                            local.id_local,
                            'administrator/locals/getLocal'
                          )
                        "
                      >
                        <v-icon color="green" small
                          >mdi-account-multiple</v-icon
                        >
                        {{ local.name_local }}
                      </a>
                      <v-chip x-small class="ml-2">
                        {{ typeCommissionText(local.type_comission) }}
                      </v-chip>
                    </td>
                  </tr>
                  <tr
                    v-for="(agent, indexAgent) in local.agents"
                    :key="`${indexAgent} ${agent.name_agent}`"
                  >
                    <td style="width: 200px">
                      <div class="d-flex">
                        <a
                          class="blue--text ml-4"
                          @click="
                            $profile.showProfileDrawer(
                              agent.id_agent,
                              'administrator/agents/getAgent'
                            )
                          "
                        >
                          <v-icon color="blue" small>mdi-account</v-icon>
                          {{ agent.name_agent }}
                        </a>
                      </div>
                    </td>
                    <td class="caption ma-1">{{ agent.count_bets }}</td>
                    <td
                      class="caption ma-1"
                      :class="getColor(agent.sales_bets)"
                    >
                      {{ agent.sales_bets }}
                    </td>
                    <td class="caption ma-1 red--text">
                      {{ agent.commission_bets }}
                    </td>
                    <td class="caption ma-1  red--text">
                      {{ agent.prizes_paid }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(agent.comission_local)"
                    >
                      {{ agent.comission_local }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(agent.gross_profit)"
                    >
                      {{ agent.gross_profit }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(agent.comission_regional)"
                    >
                      {{ agent.comission_regional }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(agent.liquid_profit)"
                    >
                      {{ agent.liquid_profit }}
                    </td>
                  </tr>
                  <tr :key="`${local.name_local} ${index}`">
                    <td class="overline green--text ml-2">Total Local</td>
                    <td class="caption ma-1">
                      {{ local.totalLocal.count_bets }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.sales_bets)"
                    >
                      {{ local.totalLocal.sales_bets }}
                    </td>
                    <td class="caption ma-1 red--text">
                      {{ local.totalLocal.commission_bets }}
                    </td>
                    <td class="caption ma-1 red--text">
                      {{ local.totalLocal.prizes_paid }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.comission_local)"
                    >
                      {{ local.totalLocal.comission_local }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.gross_profit)"
                    >
                      {{ local.totalLocal.gross_profit }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.comission_regional)"
                    >
                      {{ local.totalLocal.comission_regional }}
                    </td>
                    <td
                      class="caption ma-1"
                      :class="getColor(local.totalLocal.liquid_profit)"
                    >
                      {{ local.totalLocal.liquid_profit }}
                    </td>
                  </tr>
                </template>

                <tr :key="`${index} ${item.name_regional}`">
                  <td class="overline orange--text">Total Regional</td>
                  <td class="caption ma-1">
                    {{ item.totalRegional.count_bets }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.sales_bets)"
                  >
                    {{ item.totalRegional.sales_bets }}
                  </td>
                  <td class="caption ma-1 red--text">
                    {{ item.totalRegional.commission_bets }}
                  </td>
                  <td class="caption ma-1 red--text">
                    {{ item.totalRegional.prizes_paid }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.comission_local)"
                  >
                    {{ item.totalRegional.comission_local }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.gross_profit)"
                  >
                    {{ item.totalRegional.gross_profit }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.comission_regional)"
                  >
                    {{ item.totalRegional.comission_regional }}
                  </td>
                  <td
                    class="caption ma-1"
                    :class="getColor(item.totalRegional.liquid_profit)"
                  >
                    {{ item.totalRegional.liquid_profit }}
                  </td>
                </tr>
              </template>
            </tbody>
          </v-simple-table>
        </div>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="data.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("resumeSummary") }}
                <v-icon
                  class="float-right mr-3 d-print-none"
                  @click="$copy(resumePrint)"
                >
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="caption">{{ $t("qtyAgents") }}</td>
                      <td class="text-right">
                        {{ resume["qtdAgents"].value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("qtyBets") }}</td>
                      <td class="text-right">
                        {{ resume["count_bets"].value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("bets") }}</td>
                      <td
                        class="text-right"
                        :class="getColor(resume['sales_bets'].value)"
                      >
                        {{ resume["sales_bets"].value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("coAgentSalesBets") }}</td>
                      <td
                        class="text-right"
                        :class="getColor(resume['commission_bets'].value)"
                      >
                        {{ resume["commission_bets"].value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("awards") }}</td>
                      <td
                        class="text-right "
                        :class="getColor(resume['prizes_paid'].value)"
                      >
                        {{ resume["prizes_paid"].value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("coGerLocal") }}</td>
                      <td
                        class="text-right "
                        :class="getColor(resume['comission_local'].value)"
                      >
                        {{ resume["comission_local"].value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("grossProfit") }}</td>
                      <td
                        class="text-right "
                        :class="getColor(resume['gross_profit'].value)"
                      >
                        {{ resume["gross_profit"].value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption ">{{ $t("coRegionalManager") }}</td>
                      <td
                        class="text-right"
                        :class="getColor(resume['comission_regional'].value)"
                      >
                        {{ resume["comission_regional"].value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("netProfit") }}</td>
                      <td
                        class="text-right"
                        :class="getColor(resume['liquid_profit'].value)"
                      >
                        {{ resume["liquid_profit"].value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- <router-view></router-view> -->
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  components: {
    HeaderPrint,
  },
  name: "administrator-financial-salesReportSimplified",
  data: () => ({
    search: "",
    breakpoint: "xs",
    data: [],
    dataTable: [],
    resume: null,
    keysResume: [],
    idRegional: "",
    idLocal: "",
    typeList: false,
    toggle_exclusive: undefined,
    headers: [],
    endpoint: "",
    valueColors: [
      "sales_bets",
      "commission_bets",
      "comission_local",
      "prizes_paid",
      "gross_profit",
      "comission_regional",
      "liquid_profit",
    ],
  }),
  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    typeLive() {
      return this.$store.state.filters.groupTypeLive.value;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },

  mounted() {
    // Table format Default;
    this.buildTableFormat("grouped");
  },

  watch: {
    saveFilters(val) {
      val && this.getSales();
    },
  },

  methods: {
    reset() {
      this.data = [];
      this.dataTable = [];
      this.idRegional = "";
      this.idLocal = "";
    },
    async getSales() {
      this.reset();

      const body = {
        ...this.rangeDate,
        id_regional: this.id_regional,
        id_local: this.id_local,
        id_agent: this.id_agent,
        export: this.exportDoc,
        tipo: this.typeLive,
      };

      let response;

      // Request Download DOC (Excel)
      if (this.exportDoc) {
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "administrator/retail/financial/salesReport",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "administrator/retail/financial/salesReport",
          body
        );
      }

      if (!response.dados) {
        this.data = [];
        return;
      }
      this.dataTable = response.dados;

      var dt_start = response.date_start.replace(" ", "T");
      var dt_end = response.date_final.replace(" ", "T");

      this.$date.buildRangeUi(dt_start, dt_end);

      this.buildGroupedReport(response.dados);
      this.buildResumeData(response.dados);
    },

    buildGroupedReport(dados) {
      // De acordo com o type_comission "bruto" ou "ngr" o valor a comissão do Local será alterada
      // Caso seja 'ngr' o valor do somatório será commission_ngr_local
      dados.forEach((item) => {
        if (item.type_comission == "ngr") {
          if (item.comission_ngr_local < "0") {
            item.comission_local = "0";
          } else {
            item.comission_local = (
              Number(item.comission_ngr_local) * -1
            ).toFixed(2);
          }
          item.gross_profit = item.gross_profit_ngr;
        } else {
          item.comission_local = (Number(item.comission_local) * -1).toFixed(2);
        }
      });
      // Fase 1
      // Reformulacao de dados trazidos da API
      // Contruindo estrutura a nível Gerente Regional
      for (let item of dados) {
        // Seto o estado inical do item do this.data
        // Esse itemData vai ser moldado com novos atributos
        // e no final vai ser adicionado no this.data responsável pela listagem
        let itemData = {};

        // Criação de 2 parametros nescessários para a listagem da table
        // São eles: Comissao do Regional, Lucro Líquido
        item.comission_regional = (
          item.gross_profit *
          (item.comission_regional / 100)
        ).toFixed(2);
        item.liquid_profit = (
          item.gross_profit - item.comission_regional
        ).toFixed(2);

        item.commission_bets = (Number(item.commission_bets) * -1).toFixed(2);
        // item.comission_local = (Number(item.comission_local) * -1).toFixed(2);
        item.prizes_paid = (Number(item.prizes_paid) * -1).toFixed(2);

        // Cria as informações a nivel Ger. Regional e
        // cria um array de Ger. Locais de sua rede
        // São eles: id_regional:String, name_regional:String, locals:Array
        if (this.idRegional != item.id_regional) {
          this.idRegional = item.id_regional;
          itemData.name_regional = item.name_regional;
          itemData.id_regional = item.id_regional;
          itemData.locals = [];
        }

        // Adiciona no "Data" Array responsável pela listagem
        itemData.name_regional && this.data.push(itemData);
      }

      // Fase 2
      // Adicionando Ger. Locais da rede de cada Ger. Regional
      for (let item_data of this.data) {
        for (let data of dados) {
          if (data.id_regional == item_data.id_regional) {
            if (this.idLocal != data.id_local) {
              this.idLocal = data.id_local;
              item_data.totalRegional = {};
              item_data.locals.push({
                id_local: data.id_local,
                name_local: data.name_local,
                type_comission: data.type_comission,
                agents: [],
              });
            }
          }
        }
      }

      // Fase 3
      // Adicionando Agents que estão da rede de cada Ger. Local
      for (let item_data of this.data) {
        for (let local_data of item_data.locals) {
          for (let data of dados) {
            if (data.id_local == local_data.id_local) {
              local_data.totalLocal = {};
              local_data.agents.push(data);
            }
          }
        }
      }

      // Soma dos Gerentes Locais
      for (let item_data of this.data) {
        for (let local_data of item_data.locals) {
          let count_bets = 0,
            sales_bets = 0,
            commission_bets = 0,
            comission_local = 0,
            prizes_paid = 0,
            gross_profit = 0,
            comission_regional = 0,
            liquid_profit = 0;

          for (let agent_data of local_data.agents) {
            count_bets = count_bets + Number(agent_data.count_bets);
            sales_bets = sales_bets + Number(agent_data.sales_bets);
            commission_bets =
              commission_bets + Number(agent_data.commission_bets);
            comission_local =
              comission_local + Number(agent_data.comission_local);
            prizes_paid = prizes_paid + Number(agent_data.prizes_paid);
            gross_profit = gross_profit + Number(agent_data.gross_profit);
            comission_regional =
              comission_regional + Number(agent_data.comission_regional);
            liquid_profit = liquid_profit + Number(agent_data.liquid_profit);
          }

          local_data.totalLocal.count_bets = count_bets;
          local_data.totalLocal.sales_bets = sales_bets.toFixed(2);
          local_data.totalLocal.commission_bets = commission_bets.toFixed(2);
          local_data.totalLocal.comission_local = comission_local.toFixed(2);
          local_data.totalLocal.prizes_paid = prizes_paid.toFixed(2);
          local_data.totalLocal.gross_profit = gross_profit.toFixed(2);
          local_data.totalLocal.comission_regional = comission_regional.toFixed(
            2
          );
          local_data.totalLocal.liquid_profit = liquid_profit.toFixed(2);
        }
      }

      // Soma dos Gerentes Regionais
      for (let item_data of this.data) {
        let count_bets = 0,
          sales_bets = 0,
          commission_bets = 0,
          comission_local = 0,
          prizes_paid = 0,
          gross_profit = 0,
          comission_regional = 0,
          liquid_profit = 0;

        for (let local_data of item_data.locals) {
          count_bets = count_bets + Number(local_data.totalLocal.count_bets);
          sales_bets = sales_bets + Number(local_data.totalLocal.sales_bets);
          commission_bets =
            commission_bets + Number(local_data.totalLocal.commission_bets);
          comission_local =
            comission_local + Number(local_data.totalLocal.comission_local);
          prizes_paid = prizes_paid + Number(local_data.totalLocal.prizes_paid);
          gross_profit =
            gross_profit + Number(local_data.totalLocal.gross_profit);
          comission_regional =
            comission_regional +
            Number(local_data.totalLocal.comission_regional);
          liquid_profit =
            liquid_profit + Number(local_data.totalLocal.liquid_profit);
        }

        item_data.totalRegional.count_bets = count_bets;
        item_data.totalRegional.sales_bets = sales_bets.toFixed(2);
        item_data.totalRegional.commission_bets = commission_bets.toFixed(2);
        item_data.totalRegional.comission_local = comission_local.toFixed(2);
        item_data.totalRegional.prizes_paid = prizes_paid.toFixed(2);
        item_data.totalRegional.gross_profit = gross_profit.toFixed(2);
        item_data.totalRegional.comission_regional = comission_regional.toFixed(
          2
        );
        item_data.totalRegional.liquid_profit = liquid_profit.toFixed(2);
      }

      // Alterando os valores da comissão do regional
      // Nesta operação quando o lucro bruto é negativo o regional paga para o operador
      // Quando o lucro é positivo o operador paga ao regional
      this.data.forEach((data) => {
        // Altera o somatório da linha "TOTAL LOCAL"
        data.locals.forEach((local) => {
          local.totalLocal.comission_regional =
            local.totalLocal.comission_regional * -1;
        });
        // Altera o somatório da linha "TOTAL REGIONAL"
        data.totalRegional.comission_regional =
          data.totalRegional.comission_regional * -1;
      });
    },

    buildResumeData(data) {
      if (!data) return;
      // Inverte o valor da Comissão Regional no Resumo
      data.forEach((item) => {
        item.comission_regional = Number(item.comission_regional) * -1;
      });
      const sum = (key) => {
        // console.log(data);
        return data
          .map((item) => Number(item[key]))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);
      };

      let resume = {
        sales_bets: {},
        commission_bets: {},
        comission_local: {},
        prizes_paid: {},
        gross_profit: {},
        comission_regional: {},
        liquid_profit: {},
      };
      // console.log("sum", sum);
      Object.keys(resume).forEach((key) => {
        const total = sum(key);
        resume[key].classColor = this.getColor(total);

        resume[key].value = total;
      });

      const complement = {
        qtdAgents: { value: data.length },
        count_bets: { value: Number(sum("count_bets")) },
      };

      this.resume = { ...complement, ...resume };
      this.keysResume = Object.keys(this.resume);

      this.resumeExcelCopy();
    },

    resumeExcelCopy() {
      // Create String with table to Copy on Btn
      this.resumePrint = `
        ${this.resume.qtdAgents.value.toString().replace(".", ",")}
        ${this.resume.count_bets.value.toString().replace(".", ",")}
        ${this.resume.sales_bets.value.toString().replace(".", ",")}
        ${this.resume.commission_bets.value.toString().replace(".", ",")}
        ${this.resume.prizes_paid.value.toString().replace(".", ",")}
        ${this.resume.comission_local.value.toString().replace(".", ",")}
        ${this.resume.gross_profit.value.toString().replace(".", ",")}
        ${this.resume.comission_regional.value.toString().replace(".", ",")}
        ${this.resume.liquid_profit.value.toString().replace(".", ",")}`;
    },

    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    buildTableFormat(format) {
      // HEADERS DEFAULT

      this.headers = [
        { text: this.$t("qtyBet"), value: "count_bets" },
        { text: this.$t("salesBets"), value: "sales_bets" },
        // { text: this.$t("cancelledBets"), value: "cancellations" },
        {
          text: this.$t("coAgentBet"),
          value: "commission_bets",
        },
        { text: this.$t("awards"), value: "prizes_paid" },
        {
          text: this.$t("coGerLocal"),
          value: "comission_local",
        },
        { text: this.$t("grossProfit"), value: "gross_profit" },
        { text: this.$t("coRegionalManager"), value: "comission_regional" },
        { text: this.$t("netProfit"), value: "liquid_profit" },
      ];

      if (format === "grouped") {
        this.typeList = false;
        const users = {
          text: this.$t("users"),
          value: "name_agent",
        };
        this.headers.unshift(users);
      }

      if (format === "list") {
        this.typeList = true;
        const users = [
          {
            text: this.$t("agent"),
            value: "name_agent",
          },
          {
            text: this.$t("local"),
            value: "name_local",
          },
          {
            text: this.$t("regional"),
            value: "name_regional",
          },
        ];
        users.forEach((item) => this.headers.unshift(item));
      }
    },
    typeCommissionText(type_comission) {
      const commissionLocal = {
        ngr: "NGR",
        bruto: this.$t("gross"),
      };
      return commissionLocal[type_comission];
    },
    TranslateKey: function(key) {
      const myKeysTranslated = {
        qtdAgents: this.$t("qtyAgents"),
        comission_regional: this.$t("coRegionalManager"),
        count_bets: this.$t("qtyBet"),
        sales_bets: this.$t("bets"),
        commission_bets: this.$t("coAgentBet"),
        prizes_paid: this.$t("awards"),
        comission_local: this.$t("coGerLocal"),
        liquid_profit: this.$t("netProfit"),
        gross_profit: this.$t("grossProfit"),
      };

      return myKeysTranslated[key] || null;
    },
    infoKey: function(key) {
      const info = {
        name_agent: this.$t("agentName"),
        qtdAgents: this.$t("numbersOfAgents"),
        comission_regional: this.$t("commissionRegionalOnGrossProfit"),
        count_bets: this.$t("amountBetsSold"),
        sales_bets: this.$t("bettingSalesValue"),
        commission_bets: this.$t("agentsCommissiononBettingSales"),
        prizes_paid: this.$t("awardValue"),
        comission_local: this.$t("localManagerCommissionInfoKey"),
        liquid_profit: this.$t("netProfitResume"),
        gross_profit: this.$t("groosProfitResume"),
      };

      return info[key] || null;
    },
  },
};
</script>
